import { Component } from '@angular/core';
import { NavParams, ViewController, ModalController } from 'ionic-angular';

import { AlertService } from '../../../providers/alert-service';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

import { RolresponsaveisService } from '../../../providers/rolresponsaveis-service';

import { ModalArquivosPage } from '../modal-arquivos/modal-arquivos';
import { GestaoPcaService } from "../../../providers/gestao-pca-service";

@Component({
    selector: 'page-modal-portarias',
    templateUrl: 'modal-portarias.html',
    providers: [
        RolresponsaveisService
    ]
})
export class ModalPortariasPage {
    portariaParaAdicionar: any;
    portariaParaEditar: any;

    codigoModulo: any = null;

    objetoRetorno: any = {
        salvar: false,
        periodoFuncao: ''
    };

    user: any;
    PCAAtiva: any;
    listaPublicacao: any = [];
    listaAtos: any = [];
    periodoFuncao: any;
    isJurisdicionado: any;
    isCGE: any;
    isUmRegistro: any;

    myDatePickerNomeacaoOptions: IMyDpOptions;
    myDatePickerPublicacaoOptions: IMyDpOptions;

    analise: any = null;

    constructor(public rolresponsaveisService: RolresponsaveisService,
        private viewCtrl: ViewController,
        public modalCtrl: ModalController,
        private alertService: AlertService,
        public gestaoPcaService: GestaoPcaService,
        public navParams: NavParams) {
            
        this.objetoRetorno = {
            salvar: false,
            periodoFuncao: ""
        };
        this.PCAAtiva = this.gestaoPcaService.getPCA();
        
        this.periodoFuncao = this.navParams.get('periodoFuncao');
        this.isJurisdicionado = this.navParams.get('jurisdicionado');
        this.isCGE = this.navParams.get('isCGE');
        this.isUmRegistro = this.navParams.get('isUmRegistro');

        this.analise = this.navParams.get('analise');
        this.codigoModulo = this.analise.idModuloPca;

        this.carregarTiposAtos();
        this.carregarTiposPublicacao();
        this.limparCamposPortaria();

        this.myDatePickerNomeacaoOptions = this.getDatePickerOptions();
        this.myDatePickerPublicacaoOptions = this.getDatePickerOptions();
    }

    carregarTiposAtos() {
        this.rolresponsaveisService.buscarTiposAtos().subscribe(data => {
            this.listaAtos = data;
        },
            error => {
                console.log("erro: " + error);
            });
    }

    carregarTiposPublicacao() {
        this.rolresponsaveisService.listarTipoPublicacao().subscribe(data => {
            this.listaPublicacao = data;
        },
            error => {
                console.log("erro: " + error);
            });
    }

    adicionarPortaria() {
        
        if (this.portariaParaAdicionar.numPaginado !== '' &&
            this.portariaParaAdicionar.tipoAto.dsTipoAto != '' &&
            this.portariaParaAdicionar.dataNomeacao != '' &&
            this.portariaParaAdicionar.dataPublicacao != '' &&
            this.portariaParaAdicionar.dscTipoPublicacao != '') {                        
            
            let tipoAtoTemp = this.listaAtos.filter((ato) => this.portariaParaAdicionar.tipoAto.dsTipoAto == ato.dsTipoAto)[0];
            let tipoPublicacaoTemp = this.listaPublicacao.filter((publicacao) => this.portariaParaAdicionar.dscTipoPublicacao == publicacao.descricao)[0];

            if (tipoAtoTemp != null) {
                this.portariaParaAdicionar.tipoAto.idTipoAto = tipoAtoTemp.idTipoAto;
            }

            if (tipoPublicacaoTemp != null) {
                this.portariaParaAdicionar.prefTipoPublicacao = tipoPublicacaoTemp.prefixo;
            }

            this.periodoFuncao.portarias.push(this.portariaParaAdicionar);
            this.portariaParaEditar = null;
            this.limparCamposPortaria();           

            this.myDatePickerPublicacaoOptions = this.getDatePickerOptions();
            this.myDatePickerNomeacaoOptions = this.getDatePickerOptions();
        } else {
            this.alertService.mostraAlerta("Atenção", "Preencha todos os campos.");
        }
    }

    removerPortaria(portaria) {
        let index = this.periodoFuncao.portarias.indexOf(portaria);
        this.periodoFuncao.portarias.splice(index, 1);        
        
        this.rolresponsaveisService.deletarPortaria(portaria.idPortaria).subscribe(data => {
            this.alertService.mostraAlerta("", data.mensagem);
        }, error => {
            this.periodoFuncao.portarias.push(portaria);
            this.alertService.mostraAlerta("", error.mensagem);
        });
    }

    limparCamposPortaria() {
        this.portariaParaAdicionar = {
            "idPortaria": 0,
            "dataNomeacao": "",
            "dataPublicacao": "",
            "tipoAto": {
                "idTipoAto": 0,
                "dsTipoAto": ""
            },
            "numPaginado": "",
            "idPeriodoFuncao": 0,
            "dscTipoPublicacao": "",
            "prefTipoPublicacao": "",
            "arquivos": []
        };
    }

    abrirArquivo() {
        let titulo = "Atos de Nomeação";

        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: this.periodoFuncao.idPeriodoFuncao,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: '21',
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemFilter: 'ROL DE RESPONSÁVEIS',
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();
    }

    onDataNomeacaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.portariaParaAdicionar.dataNomeacao = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    onDataPublicacaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.portariaParaAdicionar.dataPublicacao = new Date(event.jsdate).toLocaleDateString('pt-br');  
        }
    }

    dismiss() {
        this.objetoRetorno.salvar = false;        
        if(this.portariaParaEditar) {
            this.periodoFuncao.portarias.push(this.portariaParaEditar);
        }
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    salvarEdicao() {
        this.objetoRetorno.salvar = true;
        if(this.portariaParaEditar) {
            this.periodoFuncao.portarias.push(this.portariaParaEditar);
        }
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    editar(item) {
        this.portariaParaEditar = item;
        
        this.portariaParaAdicionar = {...item};
        this.portariaParaAdicionar.tipoAto = {...item.tipoAto}

        let index = this.periodoFuncao.portarias.indexOf(item);
        this.periodoFuncao.portarias.splice(index, 1);
    }

    getDatePickerOptions() {
        return {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            editableDateField: false,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            showSelectorArrow: false
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-portarias/modal-portarias.ts